<template>
  <v-row class="pa-0 ma-0 b-BOX-GREY-DARK">
    <v-col cols="12" class="pa-0">
      <v-row align="center" class="b-B-GREY-DARK" style="height: 41px;" color="transparent" no-gutters>
        <v-col cols="1" class="pa-0 d-flex flex-column" align="center">
          <v-sheet class="customHeader text-hidden" color="transparent">
            <span style="font-size: 0.625rem;" class="transparent--text">{{ '_' }}</span>
          </v-sheet>
        </v-col>
        <v-col cols="9" class="pa-0 d-flex flex-column" style="height: 41px;">
          <v-row style="height: 25px;" no-gutters>
            <v-col v-for="x in 12" :cols="1" :align="'center'" class="pa-0 b-B-GREY-DARK" :key="x">
              <v-sheet class="pa-0 customHeader text-hidden" color="transparent">
                <span style="font-size: 0.625rem;">{{ (x >= 10 ? x - 9 : x + 3) + '月' }}</span>
              </v-sheet>
            </v-col>
          </v-row>
          <v-row justify="center" align="center" style="line-height: 16px;" no-gutters>
            <v-col v-for="x in 12" :cols="1" align="center" class="pa-0" style="line-height: 16px;" :key="x">
              <v-row no-gutters>
                <v-col cols="6" class="pa-0">
                  <v-sheet class="pa-0 customHeader" color="transparent" style="display: block !important;">
                    <span style="font-size: 0.625rem; display: block !important;">入</span>
                  </v-sheet>
                  </v-col>
                <v-col cols="6" class="pa-0">
                  <v-sheet class="pa-0 customHeader" color="transparent" style="display: block !important;">
                    <span style="font-size: 0.625rem; display: block !important;">退</span>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1" class="pa-0 d-flex flex-column" align="center" v-for="(item, index) in title" :key="index">
          <v-row style="height: 25px;" no-gutters>
            <v-col cols="12" :align="'center'" class="pa-0 b-B-GREY-DARK">
              <v-sheet class="pa-0 customHeader text-hidden" color="transparent">
                <span style="font-size: 0.625rem;">{{ item }}</span>
              </v-sheet>
            </v-col>
          </v-row>
          <v-row justify="center" align="center" style="line-height: 16px;" no-gutters>
            <v-col cols="6" class="pa-0">
              <v-sheet class="pa-0 customHeader" color="transparent" style="display: block !important;">
                <span style="font-size: 0.625rem; display: block !important;">入</span>
              </v-sheet>
              </v-col>
            <v-col cols="6" class="pa-0">
              <v-sheet class="pa-0 customHeader" color="transparent" style="display: block !important;">
                <span style="font-size: 0.625rem; display: block !important;">退</span>
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1" class="pa-0 d-flex flex-column" align="center"></v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="pa-0" align="center">
          <div class='overflow-y-auto'>
            <RecycleScroller
              class="scroller"
              :items="myItems"
              :item-size="16"
              key-field="key"
            >
              <template v-slot="{ item }">
                <v-sheet :color="item.color" style="height: 16px; line-height: 16px;">
                  <v-row align="center" justify="center" style="height: 16px;" no-gutters>
                    <v-col cols="1" class="pa-0 pl-1" style="line-height: 16px;" :align="item.align">
                      <span style="font-size: 0.625rem; line-height: 16px;" class="text-hidden">{{ item.title }}</span>
                    </v-col>
                    <v-col cols="9" class="pa-0 ma-0" style="line-height: 16px;">
                      <v-row no-gutters  style="line-height: 16px;">
                        <v-col v-for="x in 12" :cols="1" align="center" class="pa-0" style="line-height: 16px;" :key="x">
                          <v-row no-gutters>
                            <v-col cols="6" class="pa-0">
                              <v-sheet class="pa-0" color="transparent" style="display: block !important;">
                                <span style="font-size: 0.625rem; display: block !important; color: #1976D2;">{{ item.s5[x - 1] + item.suffix }}</span>
                              </v-sheet>
                              </v-col>
                            <v-col cols="6" class="pa-0">
                              <v-sheet class="pa-0" color="transparent" style="display: block !important;">
                                <span style="font-size: 0.625rem; display: block !important;">{{ item.s7[x - 1] + item.suffix }}</span>
                              </v-sheet>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="1" class="pa-0 pr-1" :align="'end'" style="line-height: 16px;">
                      <v-row no-gutters>
                        <v-col cols="6" class="pa-0">
                          <v-sheet class="pa-0" color="transparent" style="display: block !important;">
                            <span style="font-size: 0.625rem; display: block !important; color: #1976D2;">{{ item.sum5 + item.suffix }}</span>
                          </v-sheet>
                          </v-col>
                        <v-col cols="6" class="pa-0">
                          <v-sheet class="pa-0" color="transparent" style="display: block !important;">
                            <span style="font-size: 0.625rem; display: block !important;">{{ item.sum7 + item.suffix }}</span>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="1" class="pa-0 pr-1" :align="'end'" style="line-height: 16px;">
                      <v-row no-gutters>
                        <v-col cols="6" class="pa-0">
                          <v-sheet class="pa-0" color="transparent" style="display: block !important;">
                            <span style="font-size: 0.625rem; display: block !important; color: #1976D2;">{{ item.sum5ttl + item.suffix }}</span>
                          </v-sheet>
                          </v-col>
                        <v-col cols="6" class="pa-0">
                          <v-sheet class="pa-0" color="transparent" style="display: block !important;">
                            <span style="font-size: 0.625rem; display: block !important;">{{ item.sum7ttl + item.suffix }}</span>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-sheet>
              </template>
            </RecycleScroller>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['item', 'yyyy', 'mm', 'value', 'group', 'prev'],
  computed: {
    headers () {
      var temp = []
      temp.push({ title: '在籍', key: 17, align: 'start', prefix: '', suffix: '', calc: 'ave' })
      if (this.item.schools.preschool) {
        if (this.item.schools.extension === 1) {
          temp.push({ title: '幼児', key: 30, align: 'start', prefix: '', suffix: '', calc: 'ave' })
        } else {
          temp.push({ title: '幼児', key: 0, align: 'start', prefix: '', suffix: '', calc: 'ave' })
        }
      }
      temp.push({ title: '小学部', key: 14, align: 'end', prefix: '', suffix: '', calc: 'ave' })
      temp.push({ title: '中学部', key: 15, align: 'end', prefix: '', suffix: '', calc: 'ave' })
      temp.push({ title: '高校部', key: 16, align: 'end', prefix: '', suffix: '', calc: 'ave' })
      return temp
    },
    myItems () {
      var temp = []
      var status = []
      for (var i in this.headers) {
        var s5 = this.item['status_5'][this.yyyy][this.group].map(v => {
          return v[this.headers[i].key]
        })
        var s7 = this.item['status_7'][this.yyyy][this.group].map(v => {
          return v[this.headers[i].key]
        })
        status.push({
          'key': this.headers[i].key,
          'title': this.headers[i].title,
          'align': 'start',
          's5': s5,
          's7': s7,
          'sum5': (this.item['status_5_sum'][this.yyyy][this.group][2][this.headers[i].key]).toFixed(1),
          'sum7': (this.item['status_7_sum'][this.yyyy][this.group][2][this.headers[i].key]).toFixed(1),
          'sum5ttl': this.item['status_5_sum'][this.yyyy][this.group][0][this.headers[i].key],
          'sum7ttl': this.item['status_7_sum'][this.yyyy][this.group][0][this.headers[i].key],
          'prefix': '',
          'suffix': '',
          'color': '#BBDEFB80'
        })
      }
      var prevs = []
      if (this.prev) {
        var prev = this.yyyy - 1
        var s5id = this.value ? 'status_5_diff' : 'status_5'
        var s7id = this.value ? 'status_7_diff' : 'status_7'
        if (prev >= 2018) {
          for (i in status) {
            s5 = this.item[s5id][prev][this.group].map((v) => {
              return v[status[i].key]
            })
            s7 = this.item[s7id][prev][this.group].map((v) => {
              return v[status[i].key]
            })
            prevs.push({
              'key': 'prev' + status[i].key,
              'title': this.value ? '昨年' : '昨年',
              'align': 'end',
              's5': s5,
              's7': s7,
              'sum5': this.value ? this.item[s5id + '_sum'][prev][this.group][2][this.headers[i].key] : (this.item[s5id + '_sum'][prev][this.group][2][this.headers[i].key]).toFixed(1),
              'sum7': this.value ? this.item[s7id + '_sum'][prev][this.group][2][this.headers[i].key] : (this.item[s7id + '_sum'][prev][this.group][2][this.headers[i].key]).toFixed(1),
              'sum5ttl': this.value ? this.item[s5id + '_sum'][prev][this.group][3][this.headers[i].key] : this.item[s5id + '_sum'][prev][this.group][0][this.headers[i].key],
              'sum7ttl': this.value ? this.item[s7id + '_sum'][prev][this.group][3][this.headers[i].key] : this.item[s7id + '_sum'][prev][this.group][0][this.headers[i].key],
              'prefix': '',
              'suffix': this.value ? '%' : '',
              'color': ''
            })
          }
        }
      }
      for (i in status) {
        temp.push(status[i])
        if (prevs.length !== 0) {
          temp.push(prevs[i])
        }
      }
      return temp
    }
  },
  data () {
    return {
      title: ['平均', '合計']
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
